import styled, { createGlobalStyle, ThemeProps } from 'styled-components';
import { ThemeType } from '../../../../theme/themeType';

const Wrapper = styled.div`
  padding: 0 16px;
  
  form {
    display: flex;

    .details-container {
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 669px;
      padding: 24px 16px 24px 0;

      .form-title {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
      }

      .driver-info {
        font-family: ManropeLight, sans-serif;
        color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
        font-size: 13px;
      }
    }

    .remove-avatar {
      font-family: ManropeBold, sans-serif;
      font-size: 13px;
      width: 140px;
      white-space: nowrap;
      background: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
      border-radius: 12px;
      padding: 16px;
      text-align: center;

      &:hover {
        color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.red};
        transition: color 0.3s;
      }
    }

    .blocked {
      pointer-events: none;
      background: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
      color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
    }

    .preview-container {
      width: 351px;
      padding: 24px 0 24px 16px;

      .preview-card {
        height: 496px;
        width: 100%;
        background: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
        border-radius: 12px;
        padding: 16px;

        .preview-card-title {
          width: 100%;
          height: 54px;
          text-align: center;
          font-size: 16px;
          line-height: 22px;
        }

        .preview-card-tags-container {
          height: 360px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 100%;

          .avatar-button {
            display: flex;
            padding: 0;
            border: 0;
            background: none;
            cursor: pointer;
          }

          img {
            max-width: 100px;
            max-height: 100px;
            margin-bottom: 8px;
            height: 175px;
            object-fit: cover;
          }

          .name {
            font-family: ManropeBold, sans-serif;
            font-size: 13px;
            margin-bottom: 4px;
          }

          .license {
            font-size: 13px;
            color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
            margin-bottom: 16px;
          }

          div {
            margin-bottom: 8px;
          }
        }

        .preview-card-buttons-container {
          display: flex;
          justify-content: center;
          gap: 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;

          button {
            width: 135px;
            padding: 16px 35px;
            justify-content: center;
          }

          .add-button {
            background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
            color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};

            &:hover {
              background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
              color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
            }

            &:disabled {
              cursor: default;
              background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
              color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.black};
            }
          }
        }
      }
    }
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
`;

const ErrorMessage = styled.p`
  color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

const DatePickerWrapper = styled.div<{ error?: boolean }>`
  height: 74px;
  position: relative;
  background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
  border-radius: 12px;
  border: ${(props) => (
    props.error ? `1px solid ${props.theme.colors.red}` : `1px solid ${props.theme.colors.widget_background}`
  )};
  transition: all .2s ease-in;
  width: 100%;
  max-width: 100%;

  .date-label {
    position: absolute;
    top: 16px;
    left: 16px;
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    pointer-events: none;
    z-index: 1;
  }

  .date-input-wrapper {
    width: 100%;
    height: 100%;
  }

  .date-input {
    height: 100%;
    width: 100%;
    padding: 30px 16px 10px;
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
    font-size: 13px;
    background: transparent;
    border: none;
    outline: none;
    caret-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};

    ::placeholder {
      color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
      font-size: 13px;
    }
  }

  &:has(.date-input:focus) {
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
  }

  &:hover {
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.white};
  }

  .date-error {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    font-family: ManropeLight, sans-serif;
    font-size: 11px;
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.red};
  }

  .react-datepicker-popper {
    z-index: 10;
  }

`;

export const EditDriverDatePickerGlobal = createGlobalStyle`
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker {
    font-family: inherit;
    padding: 16px;
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.outline};
    border-radius: 12px;
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
    box-shadow: ${(props: ThemeProps<ThemeType>) => props.theme.shadows.dropdown};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__header {
    background-color: transparent;
    border-bottom: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.outline};
    padding-bottom: 8px;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__current-month,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day-name,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view--selected-month,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view--selected-year,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view--down-arrow,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view--down-arrow {
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view {
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view:hover,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view:hover {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view--down-arrow,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view--down-arrow {
    display: none;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-read-view--selected-month::after,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-read-view--selected-year::after {
    content: ' ▾';
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__navigation-icon::before {
    border-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day {
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
    border-radius: 6px;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day:hover {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day--disabled {
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive};
    opacity: 0.5;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day--keyboard-selected,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__day--selected {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.black};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-dropdown {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.outline};
    border-radius: 8px;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-option {
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-option:hover {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__month-option--selected_month {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.black};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-dropdown {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_background};
    border: 1px solid ${(props: ThemeProps<ThemeType>) => props.theme.colors.outline};
    border-radius: 8px;
    max-height: 160px;
    overflow-y: scroll;
    overscroll-behavior: contain;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-option {
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.text};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-option:hover {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.widget_hover_background};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__year-option--selected_year {
    background-color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.main_cta};
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.black};
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__navigation--years-upcoming,
  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__navigation--years-previous {
    all: unset !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 20px !important;
    cursor: pointer !important;
    color: ${(props: ThemeProps<ThemeType>) => props.theme.colors.inactive} !important;
    font-size: 14px !important;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__navigation--years-upcoming::after {
    content: '▲' !important;
    display: block !important;
  }

  .driver-license-datepicker-popper.react-datepicker-popper .react-datepicker__navigation--years-previous::after {
    content: '▼' !important;
    display: block !important;
  }
`;

export default {
  Wrapper, RowContainer, ErrorMessage, DatePickerWrapper,
};
